// extracted by mini-css-extract-plugin
export default {"container":"TsgcxjLhTmGxYHHeUb2Ux","label":"_3hgmReMaAohlbvVkSZV4YX","info":"_10LhXBsYdbOWI8T9jTb0Tv"};